import type { PersonaScriptBroadcastSource } from "@nexus/contracts";
import { Icon, cn } from "@nexus/ui";
import { useTranslation } from "react-i18next";

import { useIsSuperTenant } from "@/features/auth/hooks/usePermissions";

/**
 * Where a Generate for tenants script came from: source tenant, set and script,
 * as stored on the script when it was written. Platform staff only (a member of
 * any SUPER_TENANT); client-tenant users never see it. Renders nothing for other
 * scripts.
 */
export function ScriptBroadcastSource({
  source,
  className,
}: {
  source: PersonaScriptBroadcastSource | null | undefined;
  className?: string;
}) {
  const { t } = useTranslation();
  const isPlatformStaff = useIsSuperTenant();
  if (!source || !isPlatformStaff) return null;

  const label = t("personaOpportunities.scripts.broadcastSource", {
    defaultValue: "From {{tenant}} · {{set}} · {{script}}",
    tenant: source.tenantName,
    set: source.setName,
    script: source.scriptTitle,
  });

  return (
    <p
      className={cn("flex min-w-0 items-center gap-1 text-[11px] text-muted-foreground", className)}
      title={label}
      data-testid="script-broadcast-source"
    >
      <Icon name="copy" size="xs" color="muted" aria-hidden />
      <span className="truncate">{label}</span>
    </p>
  );
}
